export function isCheckAgreementsOptions(options) {
    return options.checkAgreements;
}
export var UserRoles;
(function (UserRoles) {
    UserRoles["ADMIN"] = "companyAdmin";
    UserRoles["STANDARD"] = "companyBasic";
})(UserRoles || (UserRoles = {}));
//# sourceMappingURL=profiling.types.js.map